import { render, staticRenderFns } from "./DownloadStudies.vue?vue&type=template&id=adf364c0&scoped=true&"
import script from "./DownloadStudies.vue?vue&type=script&lang=js&"
export * from "./DownloadStudies.vue?vue&type=script&lang=js&"
import style0 from "./DownloadStudies.vue?vue&type=style&index=0&id=adf364c0&prod&scoped=true&lang=css&"
import style1 from "./DownloadStudies.vue?vue&type=style&index=1&id=adf364c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf364c0",
  null
  
)

export default component.exports